import { Currency, getCurrencyPrecision } from './currency';

interface FractionDigitOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  minimumSignificantDigits?: number;
  maximumSignificantDigits?: number;
}

/**
 * Resolves Intl fraction digits for a currency formatter. When the caller gave
 * no digit options, defaults to getCurrencyPrecision so display rounding does
 * not depend on the runtime's ICU data (which changed in Node 22.23, CLDR 48).
 */
export function resolveFractionDigits(
  currency: Currency,
  style: string,
  options: FractionDigitOptions
): Pick<FractionDigitOptions, 'minimumFractionDigits' | 'maximumFractionDigits'> {
  const {
    minimumFractionDigits,
    maximumFractionDigits,
    minimumSignificantDigits,
    maximumSignificantDigits,
  } = options;
  const hasDigitOptions = [
    minimumFractionDigits,
    maximumFractionDigits,
    minimumSignificantDigits,
    maximumSignificantDigits,
  ].some(digits => digits !== undefined);

  if (style !== 'currency' || hasDigitOptions) {
    return { minimumFractionDigits, maximumFractionDigits };
  }

  try {
    const precision = getCurrencyPrecision(currency);

    return { minimumFractionDigits: precision, maximumFractionDigits: precision };
  } catch {
    return { minimumFractionDigits, maximumFractionDigits };
  }
}
